import routes from '../routing/routes';

const MenuOffsidebar = [
  {
        name: 'Instellingen',
        icon: 'icon-settings',
        translate: 'sidebar:settings:main',
        submenu: [{
            name: 'Profielen',
            translate: 'sidebar:settings:profiles',
            path: routes.agenda.profiles.overview
        },
        {
            name: 'Afspraak statussen',
            translate: 'sidebar:settings:appointmentstatuses',
            path: routes.agenda.appointmentstatuses.overview
        },
        {
            name: 'Uitzonderingen',
            translate: 'sidebar:settings:exceptions',
            path: routes.agenda.exceptions.overview
        },
        {
            name: 'Blokeer tijdstip',
            translate: 'sidebar:settings:blockings',
            path: routes.agenda.blockings.overview
        },
        {
            name: 'Vakantieperiodes',
            translate: 'sidebar:settings:holidays',
            path: routes.agenda.holidays.overview
        },
        {
            name: 'Categorieën',
            translate: 'sidebar:settings:categories',
            path: routes.agenda.categories.overview
        },
        {
            name: 'Type afspraken',
            translate: 'sidebar:settings:subcategories',
            path: routes.agenda.subcategories.overview
        },
        {
            name: 'Formulieren',
            translate: 'sidebar:settings:categoryforms',
            path: routes.agenda.categoryforms.overview
        }]
    },
    {
        name: 'Persoonlijke instellingen',
        translate: 'sidebar:personalsettings:main',
        icon: 'icon-paper-clip',
        submenu: [
            {
                name: 'Mijn voorkeuren',
                translate: 'sidebar:personalsettings:mypreferences',
                path: routes.agenda.settings.personal
            },
            {
                name: 'Agenda voorkeuren',
                translate: 'sidebar:personalsettings:agendapreferences',
                path: routes.agenda.settings.agenda
            }]
    }
];

export default MenuOffsidebar;